import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { NzNotificationService } from 'ng-zorro-antd';
import { StringUtils } from '@ark-libs/ngx-utils';

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
    private lastMessages: { message: string, time: Number }[] = [];

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(map(event => this.handle(event)));
    }

    private handle(event: any) {
        if (event instanceof HttpResponse) {
            const message = this.parseMessage(event);
            if (StringUtils.isNotEmpty(message)) {
                setTimeout(() => {
                    if (this.isDuplicate(message)) return;
                    this.lastMessages.unshift({ message: message, time: (new Date()).getTime() });
                    const notificationService = this.injector.get(NzNotificationService);
                    notificationService.success(message, null);//, {nzDuration:5000}
                }, 500);
            }
        }
        return event;
    }

    // 忽略短时间之内相同的提示信息
    private isDuplicate(message: string): Boolean {
        if (message == null || this.lastMessages.length == 0) return false;

        while (this.lastMessages.length > 10) this.lastMessages.pop() // 只保留10条
        for (let i = 0; i < this.lastMessages.length; i++) {
            const lastMessage = this.lastMessages[i];
            if (lastMessage.message == message && lastMessage.time > (new Date()).getTime() - 5000) return true;
        }
        return false;
    }
    private parseMessage(response: HttpResponse<any>): string {
        let messageKey: string;
        let messageText: string;
        response.headers.keys().forEach(name => {
            // console.log("NotificationInterceptor.parseMessage() -> ", name);
            if (name.toLowerCase().endsWith('app-alert'))
                messageKey = decodeURIComponent(response.headers.get(name));
            else if (name.toLowerCase().endsWith('app-params')) {
                messageText = response.headers.get(name);
                if (StringUtils.isNumber(messageText)) messageText = null;
                else messageText = decodeURIComponent(messageText);
            }
        });
        if (messageKey) {
            if (messageKey.endsWith('.created')) messageKey = "保存成功";
            if (messageKey.endsWith('.updated')) messageKey = "保存成功";
            if (messageKey.endsWith('.deleted')) messageKey = "删除成功";
            // if(messageText) messageKey = messageKey + "("+ messageText +")";
            return messageKey;
        } else {
            return messageText;
        }
    }
}
